import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { LoggingService } from '../../services/logging/logging.service';
import { ConfirmData } from './confirm.component';
import { UnsavedChangesComponent } from './unsaved-changes.component';

@Injectable({
    providedIn: 'root'
})
export class UnsavedChangesService {
    promise: Promise<any>;

    private resolve: any;
    private reject: any;
    constructor(private dialog: MatDialog, private log: LoggingService) {}

    confirmPromise(options?: Partial<ConfirmData>): Promise<boolean> {
        this.promise = new Promise<boolean>((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        this.log.verbose({ type: 'UnsavedChangesService', options });
        const dialogConfig = new MatDialogConfig<Partial<ConfirmData>>();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.data = options || {};
        this.log.verbose({
            type: 'UnsavedChangesService:confirm',
            data: dialogConfig.data
        });

        this.dialog
            .open(UnsavedChangesComponent, dialogConfig)
            .afterClosed()
            .pipe(take(1))
            .subscribe(data => {
                this.log.verbose({
                    type: 'UnsavedChangesService:dialog:afterClosed',
                    data
                });
                if (data) {
                    this.resolve(true);
                } else {
                    this.reject();
                }
            });

        return this.promise;
    }
    confirm(options?: Partial<ConfirmData>): Observable<boolean> {
        const dialogConfig = new MatDialogConfig<Partial<ConfirmData>>();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.data = options || {};
        this.log.verbose({
            type: 'UnsavedChangesService:confirm',
            data: dialogConfig.data
        });

        return this.dialog
            .open(UnsavedChangesComponent, dialogConfig)
            .afterClosed() as Observable<boolean>;
    }
}
